import { render, staticRenderFns } from "./quicksight.vue?vue&type=template&id=a229ab42&"
import script from "./quicksight.vue?vue&type=script&lang=js&"
export * from "./quicksight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports